import { isNilOrEmpty } from 'ramda-extension';

import {
  createGameOrderUrl,
  membershipUrl,
  startOrderUrl,
} from '../url-builders';

export const getJoinGameAction = ({
  gameId,
  gameType,
  membershipOfferId,
  startOrderParams,
  paymentPlan,
  promoCode,
  redirectToMembership,
}) => {
  if (!isNilOrEmpty(startOrderParams)) {
    return startOrderUrl({ gameId, ...startOrderParams });
  } else if (redirectToMembership) {
    return membershipUrl({
      gameId,
      gameType,
      offerId: membershipOfferId,
      paymentPlan,
      product: gameType,
      promoCode,
    });
  } else {
    return createGameOrderUrl({ gameId, product: gameType });
  }
};
